module.exports = __webpack_public_path__ + "images/help/icon-twr44@2x-5bf58856335c633e02e7b7f1d6cce67f.png";